import { jsx as _jsx } from "react/jsx-runtime";
import { isNil } from 'ramda';
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
const context = createContext(null);
const Provider = context.Provider;
export const ColumnsMaxWidthsContext = ({ children }) => {
    const [widths, setWidths] = useState({});
    const setWidth = useCallback((fieldName, width) => setWidths((prev) => {
        const current = prev[fieldName];
        if ((current || 0) >= width) {
            return prev;
        }
        return {
            ...prev,
            [fieldName]: width,
        };
    }), []);
    const value = useMemo(() => ({ widths, setWidth }), [setWidth, widths]);
    return _jsx(Provider, { value: value, children: children });
};
const useMaxWidthsContext = (hookName) => {
    const contextValue = useContext(context);
    if (isNil(contextValue)) {
        throw new Error(`useWidthsContext must be used within a ${hookName}`);
    }
    return contextValue;
};
export const useMaxColumnWidth = (fieldName) => {
    const { widths } = useMaxWidthsContext('useGetColumnWidth');
    return widths[fieldName];
};
export const useSetMaxColumnWidth = (fieldName) => {
    const { setWidth } = useMaxWidthsContext('useSetColumnWidth');
    return useCallback((width) => setWidth(fieldName, width), [fieldName, setWidth]);
};
//# sourceMappingURL=ColumnWidthsContext.js.map